// extracted by mini-css-extract-plugin
module.exports = {"donationMessage":"jgp-3YAE9"};